import { toast } from 'react-toastify';
import ApiService from '../apiService';

export const newsletterSignup = async email => {
  try {
    const emailData = {
      email: email
    };
    const response = await ApiService.post(
      '/crm/campaign/signup?event=home-energy-newsletter',
      emailData
    );

    if (response.data.eventInstanceId && response.data.eventInstanceId.length) {
      response.message = 'success';
    }

    return response;
  } catch (error) {
    toast.error(error);
    throw error;
  }
};
